import { render, staticRenderFns } from "./NewPasswordRestore.vue?vue&type=template&id=b9820904&"
import script from "./NewPasswordRestore.vue?vue&type=script&lang=js&"
export * from "./NewPasswordRestore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports